"use client";
import { createContext, useContext } from "react";

export type LoadingContextType = {
    isLoading: boolean;
};

export const LoadingContext = createContext<LoadingContextType>({
    isLoading: false,
});

export function useGlobalLoading() {
    return useContext(LoadingContext);
}
